import React from 'react'
import {Link} from 'react-router-dom'



const DevotionalHomeBannerContainer = (props) => {
    
     const {bannerSectionItems}=props;

    return (
    <>
      {bannerSectionItems.map((item,index) =>    <div className='col-6 col-sm-4 devotional-home-banner-container-col' key={index}>
        <div className='devotional-home-banner-container' >
             <a href={item.yurl} target='_blank' rel='noreferrer'><img src={item.imgurl} alt="devotional-home-banner-img" /></a>
        </div>
        </div>)}
        </>
    )
}

export default DevotionalHomeBannerContainer;